"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButtonWithLabelGroupWidget = exports.RadioLayoutType = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var TypeStyle = require("typestyle");
var TabStyles_1 = require("../../styles/TabStyles");
var Declarative_1 = require("../../utils/Declarative");
var DomUtil_1 = require("../../utils/DomUtil");
var SelectorShims_1 = require("./SelectorShims");
var RadioLayoutType;
(function (RadioLayoutType) {
    RadioLayoutType[RadioLayoutType["Veritical"] = 0] = "Veritical";
    RadioLayoutType[RadioLayoutType["Horizontal"] = 1] = "Horizontal";
})(RadioLayoutType = exports.RadioLayoutType || (exports.RadioLayoutType = {}));
var StyleName = TypeStyle.style({
    $nest: {
        '&.horizontal': { display: 'flex', flexWrap: 'wrap' },
        '&.horizontal.justify': { justifyContent: 'space-between' },
        '&.horizontal > :not(:last-child)': { marginRight: TabStyles_1.TabStyles.Spacing.ExtraLargeSpace },
    }
});
/** Displays a group of radio options */
var RadioButtonWithLabelGroupWidget = /** @class */ (function (_super) {
    tslib_1.__extends(RadioButtonWithLabelGroupWidget, _super);
    function RadioButtonWithLabelGroupWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.groupId = DomUtil_1.generateId();
        if (!props.ariaLabel && !props['aria-labelledby'] && !props['aria-label']) {
            // tslint:disable-next-line:no-console
            console.trace('either aria-label or aria-labelledby should be provided for WCAG compliance');
        }
        return _this;
    }
    RadioButtonWithLabelGroupWidget.prototype.render = function () {
        var _this = this;
        // tslint:disable-next-line:max-line-length
        var _a = this.props, ariaLabel = _a.ariaLabel, buttonList = _a.buttonList, checkedIndex = _a.checkedIndex, handleChange = _a.handleChange, justifyHorizontalItems = _a.justifyHorizontalItems, layout = _a.layout, name = _a.name, removeLeftMargin = _a.removeLeftMargin, testId = _a.testId, divProps = tslib_1.__rest(_a, ["ariaLabel", "buttonList", "checkedIndex", "handleChange", "justifyHorizontalItems", "layout", "name", "removeLeftMargin", "testId"]);
        var buttons = buttonList.map(function (buttonOption, index) {
            return React.createElement(SelectorShims_1.RadioButtonWithLabelWidget, tslib_1.__assign({}, buttonOption, { checked: index === checkedIndex, groupName: name || _this.groupId, handleChange: handleChange, index: index, key: index, removeLeftMargin: removeLeftMargin }));
        });
        return (React.createElement("div", tslib_1.__assign({ "data-tb-test-id": Declarative_1.makeTestId('RadioButtonWithLabelGroupWidget', testId) }, divProps, { "aria-label": ariaLabel || divProps['aria-label'], children: buttons, className: TypeStyle.classes(StyleName, divProps.className, {
                horizontal: layout === RadioLayoutType.Horizontal,
                justify: justifyHorizontalItems,
            }), role: 'radiogroup' })));
    };
    return RadioButtonWithLabelGroupWidget;
}(React.Component));
exports.RadioButtonWithLabelGroupWidget = RadioButtonWithLabelGroupWidget;
//# sourceMappingURL=RadioButtonWithLabelGroupWidget.js.map